var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreyCheckSquareOffset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4688 10.637L16.4688 18.7198C16.4688 18.9077 16.3941 19.0879 16.2613 19.2207C16.1284 19.3536 15.9482 19.4282 15.7603 19.4282L2.29981 19.4282C2.11192 19.4282 1.93172 19.3536 1.79886 19.2207C1.666 19.0879 1.59136 18.9077 1.59136 18.7198L1.59136 5.25928C1.59136 5.07139 1.666 4.89119 1.79886 4.75833C1.93172 4.62547 2.11192 4.55083 2.29981 4.55083L8.35385 4.55083",
    stroke: "#BCBFC8",
    strokeWidth: 1.41689,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7834 2.00409L9.50434 10.2832M17.7834 2.00409L13.7656 2.01316M17.7834 2.00409L17.7749 6.0224",
    stroke: "#BCBFC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreyCheckSquareOffset);
export default __webpack_public_path__ + "static/media/icon-grey-check-square-offset.3e5089d830e474b1b72a08a6ec2962da.svg";
export { ForwardRef as ReactComponent };